import { Database } from '@nozbe/watermelondb';
import User from 'shared/db/services/User';
import { UserModel } from 'shared/types/User';

import { databaseValidation } from '@/services/databaseValidation';
import { FirebaseImagesService } from '@/services/firebase/images';
import Logger from '@/services/logger';
import { UserWithColor } from '@/services/user/types';

async function mapUsersWithColors(
    users: UserModel[],
    database: Database,
): Promise<UserWithColor[]> {
    const userService = new User({
        database,
        imageService: new FirebaseImagesService(),
        logDBAction: Logger.logRecordActivity,
        validation: databaseValidation,
    });

    return await Promise.all(
        users.map(async (user) => {
            const userColor = await userService.getColorById(user.id);
            return { user, userColor };
        }),
    );
}

async function fetchUserById(
    userId: string,
    database: Database,
): Promise<UserModel | null> {
    try {
        const userService = new User({
            validation: databaseValidation,
            database,
            imageService: new FirebaseImagesService(),
            logDBAction: Logger.logRecordActivity,
        });

        const [user] = await userService.getById(userId).fetch();
        return user || null;
    } catch (error) {
        // TODO: use Logger.logWarn after https://github.com/Equinetapp/equinet-mobile/pull/4387 is merged.
        Logger.logError(`Error fetching user by id: ${error}`);
        throw error;
    }
}

export { mapUsersWithColors, fetchUserById };
